module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-summer-86192fd368fe99f7264afaa901a307da.png";